import _               from 'lodash';
import PriceMatrixCell from 'pu-react/components/PriceMatrixCell';

class Cell extends PriceMatrixCell {
  // constructor(props) {
  //   super(props);
  // }

  unitPrice() {
    const total = this.totalPrice();
    const unitPrice = total / this.props.quantity;
    // return _.round(unit_price, 2);
    return Math.round(unitPrice * 10000) / 10000;
  }

  showUnitPrice() {
    return `$${numeral(this.unitPrice()).format('0.0000')}`;
  }

  isSelected() {
    const { parameters, lineItem } = this.props;
    if (parameters === undefined) {
      return false;
    }

    return (
      _.parseInt(parameters.row_selected) === this.props.row &&
      _.parseInt(parameters.column_selected) === this.props.col &&
      parameters.quote_config_key === lineItem.quote_config_key
    );
  }

  onSelectData() {
    return {
      quantity         : this.props.quantity,
      leadTime         : this.props.leadTime,
      quote_config_key : this.props.lineItem.quote_config_key,
      supplier         : this.props.lineItem.product_key,
      parametersChanged: this.props.parametersChanged,
      unitPrice        : this.unitPrice(),
      total            : this.totalPrice(),
      row_selected     : this.currentRowIdx(),
      column_selected  : this.currentColIdx(),
    };
  }
}

export default Cell;
